import { Badge } from "@/components/ui/badge";

/** Where a referred company is now: Client, Nurture, or its prospect stage. */
export function StageBadge({ c }: { c: { category: string; stage: string | null; status: string | null } }) {
  const label = c.category === "Client" ? "Client" : c.status === "On Hold" ? "Nurture" : c.stage ?? "Identified";
  const cls = c.category === "Client" ? "bg-green-700 text-white"
    : c.stage === "MVA delivered" ? "bg-green-100 text-green-700"
    : c.stage === "Engagement proposed" ? "bg-amber-100 text-amber-800"
    : "bg-blue-100 text-blue-700";
  return <Badge className={`text-[10px] ${cls}`}>{label}</Badge>;
}
